import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withMobileContext, } from '../Context/MobileContext';
import { formatDate, DATE_FORMATS, dateToRelativeTrans, parseIsoDateOrTimestamp, } from './functions';
import { withTranslation } from 'react-i18next';
import s from './Timestamp.scss';
var Timestamp = /** @class */ (function (_super) {
    __extends(Timestamp, _super);
    function Timestamp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        return _this;
    }
    Timestamp.prototype.componentDidMount = function () {
        this.setState({ isClient: true });
    };
    Timestamp.prototype.render = function () {
        var _a = this.props, className = _a.className, timestamp = _a.timestamp, showTooltip = _a.showTooltip, isMobile = _a.isMobile, isShort = _a.isShort, isCapitalized = _a.isCapitalized, t = _a.t, i18n = _a.i18n, showFullLengthOnMobile = _a.showFullLengthOnMobile;
        if (!timestamp) {
            return null;
        }
        var relativeTrans = dateToRelativeTrans(timestamp, (isMobile && !showFullLengthOnMobile) || isShort);
        var formattedDate = formatDate(timestamp, DATE_FORMATS.DateTime.FullTimeZone, i18n.language);
        return (React.createElement("time", { "aria-label": formattedDate, dateTime: parseIsoDateOrTimestamp(timestamp).toISOString(), className: classnames(isCapitalized && s['capitalize'], className), title: showTooltip && this.state.isClient ? formattedDate : undefined, suppressHydrationWarning: true }, t(relativeTrans.key, { count: relativeTrans.value })));
    };
    Timestamp.defaultProps = {
        isCapitalized: true,
    };
    return Timestamp;
}(React.Component));
export default withMobileContext(withTranslation()(Timestamp));
//# sourceMappingURL=Timestamp.js.map